<template>
  <div>
    <a :href="item.url">
    <img :src="item.src" :alt="item.alt">
    <h3 class="focus__link-text" v-html="item.heading"></h3>
    </a>
  </div>
</template>

<script>
export default {
  props: ["item"],
  data() {
    return {};
  },
};
</script>
<style scoped>
  .focus__link-text {
    text-align: center;
  }
</style>